import {Pipe, PipeTransform} from '@angular/core';
import LinkifyIt from 'linkify-it';

@Pipe({
  name: 'linkify',
  standalone: true
})
export class LinkifyPipe implements PipeTransform {
  private linkify: LinkifyIt = new LinkifyIt();

  public transform(value: string): string {
    if (!value) {
      return value;
    }

    let result = this.normalizeUnderlineStyles(value);
    result = this.normalizeTextAlignStyles(result);
    const matches = this.linkify.match(result);

    if (!matches) {
      return result;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matches.forEach((match: { url: any; }) => {
      const url = match.url;
      const anchorTag = '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
      result = result.replace(url, anchorTag);
    });

    return result;
  }

  private normalizeUnderlineStyles(html: string): string {
    return html.replace(
      /<span\b([^>]*?)\sstyle=(['"])([^'"]*text-decoration\s*:\s*underline[^'"]*)\2([^>]*)>([\s\S]*?)<\/span>/gi,
      '<u$1$4>$5</u>'
    );
  }

  private normalizeTextAlignStyles(html: string): string {
    return html.replace(
      /<(p|div|span)\b([^>]*?)\sstyle=(['"])([^'"]*text-align\s*:\s*(center|right|left)[^'"]*)\3([^>]*)>/gi,
      (_fullMatch, tagName: string, beforeStyle: string, _quote: string, _styleValue: string, alignment: string, afterStyle: string) => {
        const mappedClass = alignment.toLowerCase() === 'center'
          ? 'text-center'
          : alignment.toLowerCase() === 'right'
            ? 'text-end'
            : 'text-start';

        const remainingAttributes = `${beforeStyle}${afterStyle}`;
        const classMatch = remainingAttributes.match(/\sclass=(['"])([^'"]*)\1/i);
        if (!classMatch) {
          return `<${tagName}${remainingAttributes} class="${mappedClass}">`;
        }

        const currentClasses = classMatch[2];
        if (currentClasses.split(/\s+/).includes(mappedClass)) {
          return `<${tagName}${remainingAttributes}>`;
        }

        const mergedClassAttribute = ` class="${currentClasses} ${mappedClass}"`;
        const updatedAttributes = remainingAttributes.replace(/\sclass=(['"])([^'"]*)\1/i, mergedClassAttribute);
        return `<${tagName}${updatedAttributes}>`;
      }
    );
  }
}
